import b from "./ghl-ui.es1170.js";
import { createTheme as I } from "./ghl-ui.es855.js";
import L from "./ghl-ui.es1157.js";
import v from "./ghl-ui.es903.js";
const H = (r) => {
  const {
    textColor1: e,
    textColor2: t,
    modalColor: l,
    closeIconColor: i,
    closeIconColorHover: n,
    closeIconColorPressed: s,
    closeColorHover: c,
    closeColorPressed: C,
    infoColor: m,
    successColor: a,
    warningColor: g,
    errorColor: d,
    primaryColor: f,
    dividerColor: h,
    borderRadius: o,
    fontWeightStrong: p,
    lineHeight: u,
    fontSize: x
  } = r;
  return Object.assign(Object.assign({}, b), {
    fontSize: x,
    lineHeight: u,
    border: `1px solid ${h}`,
    titleTextColor: e,
    textColor: t,
    color: l,
    closeColorHover: c,
    closeColorPressed: C,
    closeIconColor: i,
    closeIconColorHover: n,
    closeIconColorPressed: s,
    closeBorderRadius: o,
    iconColor: f,
    iconColorInfo: m,
    iconColorSuccess: a,
    iconColorWarning: g,
    iconColorError: d,
    borderRadius: o,
    titleFontWeight: p
  });
}, S = I({
  name: "Dialog",
  common: L,
  peers: {
    Button: v
  },
  self: H
}), P = S;
export {
  P as default,
  H as self
};
